<template>
  <div class="container t">
    <div class="t__row">
      <div class="t__text">
        {{label || tipTitle}}
      </div>

      <div class="t__runway" :style="{width: `${runwaySize}px`}">
        <div class="t__progress" :style="{width: `${progressSize}px`}">

        </div>
      </div>

      <div class="t__percent">
        {{`${percent}%`}}
      </div>
    </div>
    <div class="t__row2" v-if="msg">
      <div class="t__text">
        {{msg}}
      </div>
    </div>
  </div>
</template>

<script>
const randomIntegerInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export default {
  props: {
    usage: {
      type: String,
      default: 'load'
    },
    percentStart: {
      type: Number,
      default: 20
    },
    msg: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      runwaySize: 94,
      percent: this.percentStart,
      // tipTitle: '正在添加视频背景'
    }
  },
  computed: {
    tipTitle () {
      return this.usage === 'upload'
        ? '正在上传'
        : '正在添加视频背景'
    },
    progressSize () {
      return this.percent / 100 * this.runwaySize;
    }
  },
  components: {

  },
  created () {
    this.$bus.on('videoBg.ready', ({

    } = {}) => {
      this.percent = 100;
    })
  },
  mounted () {
    if (this.usage === 'upload') {
      return;
    }

    this.updateProgress();
  },
  methods: {
    updateProgress () {
      let limit = randomIntegerInRange(65, 85);
      let tid = setInterval(() => {
        this.$nextTick(() => {
          if (this.percent >= limit) {
            clearInterval(tid);
            this.updateProgressSlow();
            return;
          }
          this.percent++;
        });
      }, 1000 / 60);
    },
    updateProgressSlow () {
      let limit = randomIntegerInRange(91, 96);
      let tid = setInterval(() => {
        this.$nextTick(() => {
          if (this.percent >= limit) {
            clearInterval(tid);
            return;
          }
          this.percent++;
        });
      }, 1000);
    },
    setComplete () {
      return new Promise((resolve, rej) => {
        this.percent = 100;
        this.$nextTick(() => {
          resolve();
        });
      })
    },
    setZero () {
      this.percent = 0;
    },
    setPercent (num) {
      this.percent = num;
    }
  }
}
</script>

<style lang="scss" scoped>
.t {
  // display: flex;
  // align-items: center;
  padding: 10px;
  background-color: rgba(#000, 0.9);
  border-radius: 4px;
  color: white;
  white-space: nowrap;

  &__text {

  }

  &__runway {
    width: 94px;
    height: 8px;
    margin-left: 9px;
    margin-right: 9px;
    border-radius: 8px;
    background-color: #b8b8b8;
  }

  &__progress {
    height: 8px;
    border-radius: 8px;
    background-color: #ffffff;
  }

  &__percent {

  }

  &__row {
    display: flex;
    align-items: center;
  }

  &__row2 {
    padding-top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tool/bgSettingBtn/tip.vue